import { useEffect } from "react";
import { useAtom } from "jotai";
import { puntajeTotalEvaluacionMecanicoAtom } from "../../BandejaEvaluacionStorage";
import usePreguntasCalidad from "./usePreguntasCalidad";
import usePreguntasProactividad from "./usePreguntasProactividad";
import usePreguntasOrientacionResultados from "./usePreguntasOrientacionResultados";
import usePreguntasRelacionesInterpersonales from "./usePreguntasRelacionesInterpersonales";
import usePreguntasLimpiezaSeguridad from "./usePreguntasLimpiezaSeguridad";
import usePreguntasTrabajoEnEquipo from "./usePreguntasTrabajoEnEquipo";
import { useState } from "react";
import usePreguntasPuntualidad from "./usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "./usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "./usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "./usePreguntasActitudTrabajoEquipo";
import usePreguntasImagenRepresentacionEmpresa from "./usePreguntasImagenRepresentacionEmpresa";
import usePreguntasPredisposicion from "./usePreguntasPredisposicion";
import usePreguntasConocimientosTecnicos from "./usePreguntasConocimientosTecnicos";
import usePreguntasCalidadTrabajo from "./usePreguntasCalidadTrabajo";
import usePreguntasProductividadEficiencia from "./usePreguntasProductividadEficiencia";
import usePreguntasResponsabilidadPuntualidad from "./usePreguntasResponsabilidadPuntualidad";
import usePreguntasTrabajoEnEquipoActitud from "./usePreguntasTrabajoEnEquipoActitud";
import usePreguntasResolucionProblemaTomaDecisiones from "./usePreguntasResolucionProblemaTomaDecisiones";

const useResultadoEvaluacionMecanico = () => {
	const { puntajeTotal: puntajeTotalConocimientosTecnicos } = usePreguntasConocimientosTecnicos();
	const { puntajeTotal: puntajeTotalCalidadTrabajo} = usePreguntasCalidadTrabajo();
	const { puntajeTotal: puntajeTotalProductividadEficiencia } = usePreguntasProductividadEficiencia();
	const { puntajeTotal: puntajeTotalResponsabilidadPuntualidad } = usePreguntasResponsabilidadPuntualidad();
	const { puntajeTotal: puntajeTotalTrabajoEquipoActitud } = usePreguntasTrabajoEnEquipoActitud();
	const { puntajeTotal: puntajeTotalResolucionProblemaTomaDecisiones } = usePreguntasResolucionProblemaTomaDecisiones();
	const [puntajeTotalEvaluacionMecanico, setPuntajeTotalEvaluacionMecanico] = useAtom(puntajeTotalEvaluacionMecanicoAtom);

	const [noAptoStyle, setNoAptoSyle] = useState("");
	const [aptoConObservacionesStyle, setAptoConObservaciones] = useState("");
	const [buenoStyle, setBuenoStyle] = useState("");
	const [destacadoStyle, setDestacadoStyle] = useState("");
	const [excelenteStyle, setExcelenteStyle] = useState("");

	const itemSeleccionado = {
		background: "#faad14",
	};

	useEffect(() => {
		setPuntajeTotalEvaluacionMecanico(
			puntajeTotalConocimientosTecnicos +
				puntajeTotalCalidadTrabajo +
				puntajeTotalProductividadEficiencia +
				puntajeTotalResponsabilidadPuntualidad +
				puntajeTotalTrabajoEquipoActitud +
				puntajeTotalResolucionProblemaTomaDecisiones
		);
	}, [
		puntajeTotalConocimientosTecnicos,
		puntajeTotalCalidadTrabajo,
		puntajeTotalProductividadEficiencia,
		puntajeTotalResponsabilidadPuntualidad,
		puntajeTotalTrabajoEquipoActitud,
		puntajeTotalResolucionProblemaTomaDecisiones,
	]);

	useEffect(() => {
		setNoAptoSyle(puntajeTotalEvaluacionMecanico >= 0 && puntajeTotalEvaluacionMecanico <= 50 ? itemSeleccionado : "");
		setAptoConObservaciones(puntajeTotalEvaluacionMecanico >= 51 && puntajeTotalEvaluacionMecanico <= 75 ? itemSeleccionado : "");
		setBuenoStyle(puntajeTotalEvaluacionMecanico >= 76 && puntajeTotalEvaluacionMecanico <= 85 ? itemSeleccionado : "");
		setDestacadoStyle(puntajeTotalEvaluacionMecanico >= 86 && puntajeTotalEvaluacionMecanico <= 95 ? itemSeleccionado : "");
		setExcelenteStyle(puntajeTotalEvaluacionMecanico >= 96 && puntajeTotalEvaluacionMecanico <= 100 ? itemSeleccionado : "");
	}, [puntajeTotalEvaluacionMecanico]);

	return {
		puntajeTotalEvaluacionMecanico,
		noAptoStyle,
		aptoConObservacionesStyle,
		buenoStyle,
		destacadoStyle,
		excelenteStyle,
	};
};

export default useResultadoEvaluacionMecanico;
